import React, { useEffect } from 'react';
import { Footer, Header, Loader } from 'components';
import { Outlet } from 'react-router-dom'
import 'components/layout/_layout.scss';
import { useDispatch, useSelector } from "react-redux";
import Sidebar from 'components/sidebar/Sidebar';
import PageContainer from './PageContainer';
import { generalActions } from 'reduxStore/reducers/generalSlice';

const SIDEBAR_MEDIUM_BREAKPOINT = 768;

function Layout() {
  const dispatch = useDispatch();
  const {loading} = useSelector(state => state.auth);
  const sidebarOpen = useSelector(state => state.general.sidebarOpen);

  // Set sidebar state once on mount based on viewport (open on large, closed on small).
  // State then persists across page changes — do not reset on navigation.
  useEffect(() => {
    const isLargeScreen = window.innerWidth >= SIDEBAR_MEDIUM_BREAKPOINT;
    dispatch(generalActions.setSidebarOpen(isLargeScreen));
  }, [dispatch]);

  return (
    <div className={'page-container'}>
      <Header/>
      <div className="main-layout">
        <button
          type="button"
          className={`sidebar-overlay ${sidebarOpen ? 'sidebar-overlay--visible' : ''}`}
          aria-label="Close menu"
          onClick={() => dispatch(generalActions.setSidebarOpen(false))}
          tabIndex={sidebarOpen ? 0 : -1}
        />
        <Sidebar isOpen={sidebarOpen} />
        <PageContainer>
          {/*{loading && <Loader/>}*/}
          <Outlet/>
        </PageContainer>
      </div>
      <Footer/>
    </div>
  );
}

export default Layout;